"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OauthPayloadIn = void 0;
class OauthPayloadIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return OauthPayloadIn.attributeTypeMap;
    }
}
exports.OauthPayloadIn = OauthPayloadIn;
OauthPayloadIn.discriminator = undefined;
OauthPayloadIn.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string",
        "format": ""
    },
    {
        "name": "redirectUri",
        "baseName": "redirectUri",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=OauthPayloadIn.js.map